import { ESpecialFlowValidationErrorCodes } from '../../types/requestFormValidation';

const SPECIAL_VALIDATION_ERROR_CODES = Object.values(ESpecialFlowValidationErrorCodes);

/* oxlint-disable typescript/no-explicit-any */
export function isSpecialFlowValidationErrorCode(code: any): code is ESpecialFlowValidationErrorCodes {
  return SPECIAL_VALIDATION_ERROR_CODES.includes(code);
}
